import * as Api from '../api';

const api = process.env.REACT_APP_ONB_API;

export const getSalesAreas = () => Api.get({ path: '/api/v1/sales-areas', api });

export const addSalesArea = () => Api.post({ path: '/api/v1/sales-areas', api });

export const updateSalesArea = (id) => Api.put({ path: `/api/v1/sales-areas/${id}`, api });
